import toArray from './toArray';
import filterArray from './filterArray';

export default function toSafeArray<T>(value: unknown | unknown[]): T {
  return filterArray(toArray(value));
}
